import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[WorkScope SetFilter] Action',
  ResetFilter: '[WorkScope ResetFilter] Action',
}

const initialWorkScopeState: IWorkScopeState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IWorkScopeState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-WorkScope', whitelist: ['filter']},
  (state: IWorkScopeState = initialWorkScopeState, action: ActionWithPayload<IWorkScopeState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialWorkScopeState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
